<template>
  <div class="TalkingIdol">
    <!-- 待機 -->
    <!-- <img src="@/assets/image/ai/AItalk_idle.gif" class="object-contain" v-show="selectedIdx === 0"> -->
    <!-- 開場打招呼 -->
    <!-- <img src="@/assets/image/ai/AItalk_hello.gif" class="object-contain" v-show="selectedIdx === 1"> -->
    <!-- 持續說話 -->
    <!-- <img src="@/assets/image/ai/AItalk_talking.gif" class="object-contain" v-show="selectedIdx === 2"> -->

    <LottieAnimation v-show="selectedIdx === 0"
      :animationData="require('@/assets/image/ai/AI_talk_Idle.json')"
      :loop="true"
      :auto-play="true"
      :speed="1" />
      <LottieAnimation v-show="selectedIdx === 1"
      :animationData="require('@/assets/image/ai/AI_talk_Hello.json')"
      :loop="true"
      :auto-play="true"
      :speed="1" />
      <LottieAnimation v-show="selectedIdx === 2"
      :animationData="require('@/assets/image/ai/AI_talk_talk.json')"
      :loop="true"
      :auto-play="true"
      :speed="1" />
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
export default {
  name: 'TalkingIdol',
  components: {
    LottieAnimation
  },
  props: {
    selectedIdx: {
      type: Number,
      default: 0
    }
  },
  setup() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .TalkingIdol {
    width: 400px;
    @media (min-width: 1440px) {
      width: 450px;
    }
  }
</style>
